import React, { useEffect, useState } from "react";

const AppContext = React.createContext();

export const AppProvider = ({ children }) => {
  const [globalValueChecker, setGlobalValueChecker] = useState("Testing Value");
  //  const [baseUrl, setBaseUrl] = useState("http://127.0.0.1:8000/api");
  // const [baseUrlForFile, setBaseUrlForFile] = useState("http://127.0.0.1:8000/storage");
  const [baseUrl, setBaseUrl] = useState("https://circlehubbackend.btsportfolio2026.com/api");
  const [baseUrlForFile, setBaseUrlForFile] = useState("https://circlehubbackend.btsportfolio2026.com/storage");
  const [selectedStudyGroupScreenName, setSelectedStudyGroupScreenName] = useState("");
  const [loggedInAdmin, setLoggedInAdmin] = useState({});
  const [loggedInStudent, setLoggedInStudent] = useState({});
  const [selectedSessionForVideocall, setSelectedSessionForVideocall] = useState(null);

  const storeSelectedSessionForVideocall = (ssfv) => {
    setSelectedSessionForVideocall(ssfv);
  };
  const storeSelectedStudyGroupScreenName = (ssgsn) => {
    setSelectedStudyGroupScreenName(ssgsn);
  };

  const storeLoggedInStudent = (student) => {
    setLoggedInStudent(student);
  };

  const storeLoggedInAdmin = (admin) => {
    setLoggedInAdmin(admin);
  };

  const storeGlobalValueChecker = (gvc) => {
    setGlobalValueChecker(gvc);
  };

  // ✅ WHITEBOARD METHOD
  const regExpChecker = (type, inp) => {
    switch (type) {

      case "email":
        if (!inp || inp.trim() === "") {
          return "Email is required";
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp)) {
          return "Invalid email format please Enter in this format 'student@gmail.com'";
        }
        break;

      case "password":
        if (!inp || inp.trim() === "") {
          return "Password is required";
        }
        if (inp.length < 6) {
          return "Password must be at least 6 characters";
        }
        break;

      default:
        return "";
    }

    return "";
  };

  return (
    <AppContext.Provider
      value={{
        globalValueChecker,
        baseUrl,
        loggedInStudent,
        selectedStudyGroupScreenName,
        loggedInAdmin,
        selectedSessionForVideocall,
        storeSelectedSessionForVideocall,
        storeLoggedInAdmin,
        storeLoggedInStudent,
        storeSelectedStudyGroupScreenName,
        storeGlobalValueChecker,
        regExpChecker   // ✅ expose
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
